module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Foreword"
    }
  }, [_vm._v("Series Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Patrick J. Deneen")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Susan J. McWilliams")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part01"
    }
  }, [_c('b', [_vm._v("Part I. Collective Consciousness and Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("1. “A Most Disagreeable Mirror”: Race Consciousness as Double Consciousness")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Lawrie Balfour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Race of a More Perfect Union: James Baldwin, Segregated Memory, and the Presidential Race")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("P. J. Brendese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. James Baldwin and the Politics of Disconnection")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Susan J. McWilliams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. What William F. Buckley Jr. Did Not Understand about James Baldwin: On Baldwin’s Politics of Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Nicholas Buccola")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part II. Prophecy, Religion, and Truth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Baldwin, Prophecy, and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("George Shulman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Negative Political Theology of James Baldwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Vincent Lloyd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Go Tell It on the Mountain:")]), _vm._v(" James Baldwin and the Politics of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Wilson Carey McWilliams")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III. The Individual Life, the Interior Life, the Unexamined Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Socrates in a Different Key: James Baldwin and Race in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Joel Alden Schlosser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Crossing Identitarian Lines: Women’s Liberation and James Baldwin’s Early Essays")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Brian Norman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. “Where the People Can Sing, the Poet Can Live”: James Baldwin, Pragmatism, and Cosmopolitan Humanism")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Ulf Schulenberg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Baldwin’s Individualism and Critique of Property")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Jack Turner")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part IV. Violence and Vision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. James Baldwin on Violence and Disavowal")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Lisa Beard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. James Baldwin and Black Lives Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Eddie S. Glaude Jr")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. “Tell Him I’m Gone”: On the Margins in High-Tech City")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('i', [_vm._v("Rachel Brahinsky")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0